"use strict";

require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.OnOffSwitch = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.regexp.to-string.js");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactHookForm = require("react-hook-form");
var _hooks = require("../../../../../hooks");
var _ValidationMessages = require("../../ValidationMessages");
var _propTypes2 = require("../../../../../propTypes");
require("./OnOffSwitch.scss");
const _excluded = ["ref"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const OnOffSwitch = _ref => {
  let {
    fieldFormContext,
    validation,
    name,
    id,
    checked,
    label = {
      checked: 'On',
      unchecked: 'Off'
    },
    labelCssClass,
    hideLabel = true,
    customCssClass = '',
    onChange,
    customTrackingData,
    customTrackingEvents
  } = _ref;
  const hookFormContext = (0, _reactHookForm.useFormContext)();
  const formContext = fieldFormContext || hookFormContext;
  const {
    register
  } = formContext || {
    register: () => {
      return {
        ref: () => {}
      };
    }
  };
  const fieldElement = (0, _react.useRef)(null);
  const [isChecked, setIsChecked] = (0, _react.useState)(checked || false);
  const [hasFocus, setHasFocus] = (0, _react.useState)(false);
  const handleChange = () => {
    const newState = !isChecked;
    setIsChecked(newState);
    if (onChange) {
      onChange(newState);
    }
  };
  const getLabelText = () => {
    if (label.checked) {
      return checked ? label.checked : label.unchecked;
    }
    return label;
  };
  const getLabelCssClass = () => {
    if (hideLabel) {
      return 'sr-only';
    }
    let labelTextCssClass = '';
    if (labelCssClass) {
      if (typeof labelCssClass === 'string') {
        labelTextCssClass = labelCssClass;
      }
      if (labelCssClass.checked && isChecked) {
        labelTextCssClass = labelCssClass.checked;
      }
      if (labelCssClass.unchecked && !isChecked) {
        labelTextCssClass = labelCssClass.unchecked;
      }
    }
    return "onOffSwitchLabel ".concat(labelTextCssClass);
  };
  (0, _hooks.useTracking)({
    elementRef: fieldElement,
    trackingProps: {
      label: 'on/off switch',
      field: {
        fieldState: formContext && formContext.getFieldState(name) || {},
        inputType: 'checkbox',
        name,
        id: id || name
      }
    },
    customTrackingData,
    customTrackingEvents
  });
  const _register = register(name, _objectSpread({}, validation)),
    {
      ref: hookFormRef
    } = _register,
    hookFormRegistration = _objectWithoutProperties(_register, _excluded);
  return /*#__PURE__*/_react.default.createElement("label", {
    className: "checkboxField onOffSwitch ".concat(customCssClass, " ").concat(isChecked ? 'on' : 'off', " ").concat(hasFocus ? 'focus' : '')
  }, /*#__PURE__*/_react.default.createElement("input", _extends({
    onFocus: () => setHasFocus(true),
    onBlur: () => setHasFocus(false),
    onClick: handleChange,
    type: "checkbox",
    defaultChecked: isChecked,
    value: isChecked.toString(),
    name: name || id,
    id: id || name
  }, hookFormRegistration, {
    ref: e => {
      hookFormRef(e);
      fieldElement.current = e;
    }
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: getLabelCssClass()
  }, getLabelText()), /*#__PURE__*/_react.default.createElement(_ValidationMessages.ValidationMessages, {
    formContext: formContext,
    name: name,
    validation: validation
  }));
};
exports.OnOffSwitch = OnOffSwitch;
OnOffSwitch.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  fieldFormContext: _propTypes.default.any,
  validation: _propTypes.default.shape(_propTypes2.ValidationPropType),
  id: _propTypes.default.string,
  name: _propTypes.default.string,
  checked: _propTypes.default.bool,
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
    checked: _propTypes.default.string,
    unchecked: _propTypes.default.string
  })]),
  labelCssClass: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
    checked: _propTypes.default.string,
    unchecked: _propTypes.default.string
  })]),
  hideLabel: _propTypes.default.bool,
  customCssClass: _propTypes.default.string,
  onChange: _propTypes.default.func,
  // eslint-disable-next-line react/forbid-prop-types
  customTrackingData: _propTypes.default.any,
  customTrackingEvents: _propTypes.default.arrayOf(_propTypes.default.string)
};
var _default = exports.default = OnOffSwitch;